import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

@Component({
    selector: 'app-component-ckeditor',
    templateUrl: './ckeditor.component.html',
    styleUrls: ['./ckeditor.component.scss']
})
export class CkeditorComponent implements OnInit, OnChanges {
    @Input() public isEnable = true;
    @Input() public isShowEditor = false;
    @Input() public isShowButtons = true;
    @Input() public inputData = '';
    @Input() public placeholder: string;
    @Output() public emitFinish: EventEmitter<[boolean, string]> = new EventEmitter<[boolean, string]>();
    public editor = Editor;
    openButtons = false;
    protected editorInstance: any;

    ngOnInit(): void {
        this.editorInstance = this.editor;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.editorInstance && !this.editorInstance.ui.focusTracker.isFocused && changes.inputData) {
            if (changes.inputData.currentValue) {
                this.editorInstance.data.set(changes.inputData.currentValue);
            } else {
                this.editorInstance.data.set('');
            }
        }
    }

    onSave(check: boolean): void {
        if (check) {
            this.isShowEditor = false;
            this.openButtons = false;
            this.emitFinish.emit([true, this.editorInstance.data.get()]);
        } else if (this.editorInstance) {
            this.emitFinish.emit([true, this.editorInstance.data.get()]);
            if (!this.inputData && !this.editorInstance.ui.focusTracker.isFocused) {
                this.editorInstance.data.set('');
                this.isShowEditor = false;
                this.openButtons = false;
            }
        }
    }

    onCancel(): void {
        this.isShowEditor = false;
        this.openButtons = false;
        if (this.inputData) {
            this.editorInstance.data.set(this.inputData);
        }
        this.emitFinish.emit([false, this.editorInstance.data.get()]);
    }

    onReady(editor: any): void {
        this.editorInstance = editor;
    }

    checkChanges(): void {
        if (!this.isShowButtons) {
            this.onSave(false);
        }
    }

    showButtons(): void {
        if (this.isShowButtons) {
            this.openButtons = true;
        }
    }
}
